import { summarizeBet, type BetSummary } from '@/lib/bet';
import type { BetBundle, BetlensResult } from '@/types';

/** One loaded bet, everything the comparison panes need in one bag. */
export interface BetSide {
  result: BetlensResult;
  bundle: BetBundle;
  summary: BetSummary;
}

export function makeSide(result: BetlensResult): BetSide {
  return { result, bundle: result.bundle, summary: summarizeBet(result.bundle) };
}
